import * as types from '../actions/Types';
import Constants from '../services/Constants';
import { RequestReducer, RequestInitReducer } from '../utils/Request';

const DEFAULT_STATE = {
  redirect: null,
  loadingCount: 0,
  isLoading: false,
  printing: false,
  selectedPlan: null,
  adminSavedSuccessfully: false,
  whatIsVisible: null,
  filterDocumentOnGrid: {},
  confirmationModalVisible: false,
  feedbackVisible: false,
  feedbackItem: null,
  feedbackClear: 0,
  ddEvent: {},
  meetingNotes: {},
  sortModel: [],
  hideUnpublished: false,
  employeeMeetingNotesAllManagerSwitch: false,
  employeeDDEventsAllManagerSwitch: false,
  letterFilter: null,
  filterBy: {
    [Constants.MY_PLANS]: {},
    [Constants.ALL_PLANS]: {},
  },
  ...RequestInitReducer([types.UI_FEEDBACK, types.UI_OPEN_PLAN]),
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case types.SELECT_PLAN: {
      return {
        ...state,
        selectedPlan: action.plan,
        filterDocumentOnGrid: {},
        filterBy: {
          [Constants.MY_PLANS]: { ...state.filterBy[Constants.MY_PLANS] },
          [Constants.ALL_PLANS]: { ...state.filterBy[Constants.ALL_PLANS] },
        },
        selectedInvestmentFirm: null,
      };
    }
    case types.REDIRECT: {
      return {
        ...state,
        redirect: action.to,
      };
    }
    case types.MAINTENANCE_STATUS: {
      return {
        ...state,
        maintenanceStatus: action.maintenanceStatus,
      };
    }
    case types.RESET_CREDENTIALS: {
      return {
        ...state,
        okta: null,
      };
    }
    case types.SET_CREDENTIALS: {
      const { okta } = action;
      const data = {
        username: okta?.idToken?.claims?.name,
        email: okta?.idToken?.claims?.email,
        token: okta?.accessToken?.accessToken,
      };
      return {
        ...state,
        okta: data,
      };
    }
    case types.LOADING: {
      const loadingCount = state.loadingCount + action.change;
      const isLoading = loadingCount > 0;
      return {
        ...state,
        loadingCount,
        isLoading,
      };
    }
    case types.USER_ACTIVATIONS_FAILED:
    case types.USER_ACTIVATIONS_STARTED: {
      return {
        ...state,
        adminSavedSuccessfully: false,
      };
    }
    case types.USER_ACTIVATIONS_SUCCESS: {
      return {
        ...state,
        adminSavedSuccessfully: true,
      };
    }
    case types.TOGGLE_WHAT_IS: {
      return {
        ...state,
        whatIsVisible: action.whatIsVisible,
      };
    }
    case types.FILTER_DOCUMENT_BY_TYPE: {
      return {
        ...state,
        filterBy: {
          ...state.filterBy,
          [action.documentView]: action.filter,
        },
      };
    }
    case types.FILTER_DOCUMENT_ON_GRID: {
      return {
        ...state,
        filterDocumentOnGrid: {
          key: action.filterKey,
          ids: action.filteredIDs,
          hasFilter: action.hasFilter,
        },
      };
    }
    case types.TOGGLE_FEEDBACK_MODAL: {
      return {
        ...state,
        feedbackVisible: action.visible,
        feedbackItem: action.data,
      };
    }
    case types.CLEAR_FEEDBACK_MODAL: {
      return {
        ...state,
        feedbackClear: state.feedbackClear + 1,
      };
    }

    case types.TOGGLE_CONFIRMATION_MODAL: {
      return {
        ...state,
        confirmationModalVisible: action.visible,
      };
    }
    case types.DISPLAY_MEETING_NOTES_SUCCESS: {
      return {
        ...state,
        meetingNotes: action.meetingNotes,
      };
    }
    case types.SHOW_DD_EVENT: {
      return {
        ...state,
        ddEvent: action.ddEvent,
      };
    }
    case types.SORT_CHANGE: {
      return {
        ...state,
        sortModel: action.sortModel,
      };
    }
    case types.HIDE_UNPUBLISHED_PLANS: {
      return {
        ...state,
        hideUnpublished: action.hide,
      };
    }
    case types.PORTFOLIOS_VIEW_MODEL: {
      return {
        ...state,
        portfoliosViewModel: action.viewModel,
      };
    }
    case types.PDF_CANVAS_SIZE: {
      return {
        ...state,
        pdfCanvasSize: action.pdfCanvasSize,
      };
    }
    case types.INVESTMENT_FIRM: {
      return {
        ...state,
        selectedInvestmentFirm: action.investmentFirm,
      };
    }
    case types.EMPLOYEE_ACTIVE_TAB: {
      return {
        ...state,
        employeeActiveTab: action.employeeActiveTab,
      };
    }
    case types.EMPLOYEE_MANAGER_MEETING_NOTES_SWITCH: {
      return {
        ...state,
        employeeMeetingNotesAllManagerSwitch: action.allManagers,
      };
    }
    case types.EMPLOYEE_DD_EVENTS_SWITCH: {
      return {
        ...state,
        employeeDDEventsAllManagerSwitch: action.allManagers,
      };
    }
    case types.PRINTING: {
      return {
        ...state,
        printing: action.printing,
      };
    }
    case types.LETTER_FILTER: {
      return {
        ...state,
        letterFilter: action.letterFilter,
      };
    }
    default: {
      return RequestReducer(
        state,
        [types.UI_FEEDBACK, types.UI_OPEN_PLAN],
        action
      );
    }
  }
};
